import { useConfigService } from '@thd-nucleus/experience-context';
import {
  getSanitizedRewardTiers,
  getSubExperienceTag
} from '../utils/promo-message-helpers';
import { FEATURE_SWITCH_KEYS } from '../utils/constants';

// Custom hook to derive promotion model values based on promotion data
export const useConditionalPromotion = ({ promotion }) => {

  // Buy X Get 1 Free (BXG1) FS from Config Service
  const isBXG1Enabled = useConfigService(FEATURE_SWITCH_KEYS.bxg1Enabled);

  // to check and get the forward reward eligibility criteria
  const sourceItemGroup = promotion?.eligibilityCriteria?.find((criterion) => criterion.itemGroup === 'SRC-1') || {};
  const sourceEligibilityCriteria = sourceItemGroup?.minThresholdVal || sourceItemGroup?.minPurchaseAmount
    || sourceItemGroup?.minPurchaseQuantity;

  // to check and get the backward reward eligibility criteria
  const targetItemGroup = promotion?.eligibilityCriteria?.find((criterion) => criterion.itemGroup === 'TGT-1') || {};
  const targetEligibilityCriteria = targetItemGroup?.minThresholdVal || targetItemGroup?.minPurchaseAmount
    || targetItemGroup?.minPurchaseQuantity;

  // sanitized reward tiers
  const rewardTiers = getSanitizedRewardTiers(promotion);
  const skuItemGroup = promotion?.skuItemGroup;
  const promotionTags = promotion?.promotionTags;
  // get experienceTag
  const experienceTag = promotion?.experienceTag || promotionTags?.[0];
  // deriving subExperience tag
  const subExperience = promotion?.subExperienceTag
    ? promotion?.subExperienceTag
    : getSubExperienceTag(
      promotionTags,
      rewardTiers,
      sourceItemGroup,
      targetItemGroup,
      skuItemGroup,
      isBXG1Enabled
    );

  return {
    experienceTag,
    subExperience,
    rewardTiers,
    sourceEligibilityCriteria,
    targetEligibilityCriteria
  };
};